import {languageProcessing} from '@axyseo/index.js';
const {AbstractResearcher} = languageProcessing;

// All config
import firstWordExceptions from './config/firstWordExceptions';
import functionWords from './config/functionWords';
import transitionWords from './config/transitionWords';
import twoPartTransitionWords from './config/twoPartTransitionWords';
import sentenceLength from './config/sentenceLength';

// All helpers
import getStemmer from './helpers/getStemmer';
import isPassiveSentence from './helpers/isPassiveSentence';

/**
 * The researcher contains all the researches, helpers, data, and config.
 */
export default class Researcher extends AbstractResearcher {
  /**
   * Constructor
   * @param {Paper} paper The Paper object that is needed within the researches.
   * @constructor
   */
  constructor(paper) {
    super(paper);

    delete this.defaultResearches.getFleschReadingScore;

    Object.assign(this.config, {
      language: 'tr',
      passiveConstructionType: 'morphological',
      firstWordExceptions,
      functionWords,
      transitionWords,
      twoPartTransitionWords,
      sentenceLength
    });

    Object.assign(this.helpers, {
      getStemmer,
      isPassiveSentence
    });
  }
}
